import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { Button, Heading } from "../../../../shared/ReusableComponents";
import CloseBtn from "../../../../shared/ReusableComponents/CloseBtn";
import { IMedicationAlert } from "./types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  maxWidth: "800px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
  backgroundColor: "#F5F5F5",
};

export default function MedicationAlert(props: IMedicationAlert) {
  const { isOpen, setIsOpen, setShowMedicationAlert, selectedFrequency } =
    props;
  const handleClose = () => setIsOpen(false);
  // const convertIntoDisplayTime = (time: string) => {
  //   const a = times.find((x) => x.value === time)?.key.substring(0, 2);
  //   const b = times.find((x) => x.value === time)?.key.substring(2);
  //   return `${a}:${b}`;
  // };
  return (
    <Fade in={isOpen}>
      <Box sx={style}>
        <CloseBtn onClose={handleClose} />
        <Box sx={{ textAlign: "center", color: "warning.main" }}>
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "60px" }}
          >
            warning
          </span>
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h6">Administration Alert</Typography>
          <Typography
            mt={2}
            sx={{ textAlign: "center", m: 2, fontSize: "1rem" }}
          >
            <Heading
              text="
            You are not administering the medicine at the scheduled time."
              font="var(--font-size-md)"
            />
          </Typography>
          <Typography pt={2} mb={"30px"}>
            <Heading
              text="Do you still want to proceed?"
              font="var(--font-size-md)"
            />
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "center",
            columnGap: "20px",
            alignItems: "center",
          }}
        >
          <Button text="Cancel" variant="outlined" onClick={handleClose} />
          <Button
            text="Proceed"
            onClick={() => setShowMedicationAlert(false)}
          />
        </Box>
      </Box>
    </Fade>
  );
}
